import { gameConstants } from '../constants';

const normalizeBlockFlag = (value) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;

    if (typeof value === 'string') {
        const normalizedValue = value.trim().toLowerCase();

        if (['true', '1', 'y', 'yes', 'blocked'].includes(normalizedValue)) {
            return true;
        }

        if (['false', '0', 'n', 'no', 'unblocked'].includes(normalizedValue)) {
            return false;
        }
    }

    return undefined;
};

const normalizeBlockedStatus = (blockedstatus, fallback = {}) => {
    const source = blockedstatus && typeof blockedstatus === 'object' ? blockedstatus : {};
    const normalizedBlockChat = normalizeBlockFlag(source.BlockChat);
    const normalizedBlockGame = normalizeBlockFlag(source.BlockGame);

    return {
        ...fallback,
        ...source,
        ...(normalizedBlockChat !== undefined ? { BlockChat: normalizedBlockChat } : {}),
        ...(normalizedBlockGame !== undefined ? { BlockGame: normalizedBlockGame } : {}),
    };
};

const initialState = {
    loading: false,
    gamesLoading: false,
    blockedStatusLoading: false,
    hasLoadedGames: false,
    hasLoadedBlockedStatus: false,
    games: [],
    blockedstatus: null,
    error: null,
};

const gameReducer = (state = initialState, action) => {
    switch (action.type) {
        case gameConstants.FETCH_GAME_REQUEST:
            return {
                ...state,
                loading: true,
                gamesLoading: true,
                error: null,
            };
        case gameConstants.FETCH_GAME_SUCCESS:
            return {
                ...state,
                loading: state.blockedStatusLoading,
                gamesLoading: false,
                hasLoadedGames: true,
                games: Array.isArray(action.games) ? action.games : [],
                error: null,
            };
        case gameConstants.FETCH_GAME_FAILURE:
            return {
                ...state,
                loading: state.blockedStatusLoading,
                gamesLoading: false,
                hasLoadedGames: true,
                error: action.error,
            };
        case gameConstants.MARK_GAME_AS_PLAYED:
            return {
                ...state,
                games: Array.isArray(state.games)
                    ? state.games.map(game =>
                        game.GameID === action.gameId
                            ? { ...game, Is_Played: 'Y' }
                            : game
                    )
                    : (state.games || []),
            };
        case gameConstants.FETCH_BLOCKEDSTATUS_REQUEST:
            return {
                ...state,
                loading: true,
                blockedStatusLoading: true,
                error: null,
            };
        case gameConstants.FETCH_BLOCKEDSTATUS_SUCCESS:
            return {
                ...state,
                loading: state.gamesLoading,
                blockedStatusLoading: false,
                hasLoadedBlockedStatus: true,
                blockedstatus: normalizeBlockedStatus(action.blockedstatus),
                error: null,
            };
        case gameConstants.FETCH_BLOCKEDSTATUS_FAILURE:
            return {
                ...state,
                loading: state.gamesLoading,
                blockedStatusLoading: false,
                hasLoadedBlockedStatus: true,
                blockedstatus: normalizeBlockedStatus(
                    state.blockedstatus || { BlockGame: false, BlockChat: false }
                ),
                error: action.error,
            };
        case gameConstants.UPDATE_BLOCKEDSTATUS_FROM_SOCKET: {
            const currentBlockedStatus =
                state.blockedstatus && typeof state.blockedstatus === 'object'
                    ? state.blockedstatus
                    : {};

            return {
                ...state,
                blockedstatus: normalizeBlockedStatus(action.blockedstatus, currentBlockedStatus),
            };
        }
        case gameConstants.PURCHASE_GAME_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case gameConstants.PURCHASE_GAME_SUCCESS:
            return {
                ...state,
                loading: false,
                games: Array.isArray(state.games)
                    ? state.games.map(game =>
                        game.GameID === action.game.GameID
                            ? { ...game, isPurchased: action.game.isPurchased }
                            : game
                    )
                    : (state.games || []),
                error: null,
            };
        case gameConstants.PURCHASE_GAME_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default gameReducer;
